(function (angular) {
    'use strict';

    angular.module('app')
        .service('confirmDialog', confirmDialog);

    confirmDialog.$inject = [
        'modalService'
    ];

    function confirmDialog(
        modalService
    ) {

        /**
         * Shows a modal with "Confirm" and "Cancel" buttons
         * @param  {string} message - Message displayed in modal
         * @return {object}         - modalService object containing result.then()
         */
        return function(message) {
            return modalService.open({
                templateUrl: 'modals/confirm.html',
                controller: 'confirmController',
                controllerAs: 'vm',
                windowClass: 'confirm',
                resolve: {
                    message: function () {
                        return message;
                    }
                }
            });
        };
    }

}(angular));
